module.exports = __webpack_public_path__ + "images/like-hover-04753fed.svg";